module.exports = __webpack_public_path__ + "media/slider/Banner-9-ca632935.jpg";